export default "__VITE_ASSET__DsdYYIgQ__"